import { Injectable } from '@angular/core';
import { DatePara } from './dateparameter-para.model'

@Injectable()

export class DateParaService{
    public formData: DatePara;
}